import { GetterTree } from 'vuex'
import { RootState } from 'types'
import { ThemeState } from '@/store/theme/themeTypes'

export const getters: GetterTree<ThemeState, RootState> = {
  theme (state): ThemeState {
    return state
  }
}
